import axios from 'axios';

export default {
  state: {
    waiting: [],
    loading: false,
    error: null,
    waitingLoaded: false,
    waitingError: false,
    waitingLoading: false
  },
  mutations: {
    SET_WAITING(state, product) {
      state.waiting = product;
      state.waitingLoaded = true; // Устанавливаем флаг, что данные загружены
    },
    SET_WAITING_LOADING(state, status) {
      state.waitingLoading = status;
    },
    SET_WAITING_ERROR(state, error) {
      state.waitingError = error;
    },
    UNSET_WAITING(state) {
      state.waitingLoaded = false;
      state.waitingLoading = false;
      state.waiting = [];
    },
  },
  actions: {
    async fetchWaiting({ commit, state }, id) {
      // Проверяем, были ли категории уже загружены
      if (state.loaded && state.product) {
        //return; // Если данные уже загружены, прекращаем выполнение
      }

      try {
        commit('SET_WAITING_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.get('api/catalog/waiting/');
        commit('SET_WAITING', response.data.data);
        commit('SET_WAITING_ERROR', null);
      } catch (error) {
        commit('SET_WAITING_ERROR', error.message || 'Ошибка при загрузке категорий');
        console.error('Error fetching product:', error);
      } finally {
        commit('SET_WAITING_LOADING', false);
      }
    }
  },
  getters: {
    waiting: state => state.waiting,
    waitingLoading: state => state.waitingLoading,
    waitingError: state => state.waitingError,
    waitingLoaded: state => state.waitingLoaded
  }
}